<template>
  <div class="match-detail">
    <div style="height: 3px; background-color: #F6F6F8;"></div>
    <div class="match">
      <div class="row">
        <div style="display: flex; align-items: center">
          <van-image style="border-radius: 4px; width: 50px; height: 50px; overflow: hidden"
            :src="imageView(match.icon, 100, 100)"></van-image>
          <div style="width: calc(100vw - 140px)">
            <div class="info">{{ match.chineseName }}</div>
            <div class="account-name">{{ match.name }}</div>
          </div>
        </div>
        <div class="cut" @click="goBack"><van-icon name="exchange" style="margin-right: 4px;font-weight: 800;" />切换</div>
      </div>
    </div>
    <div style="background-color: #F6F6F8; height: 12px;"></div>
    <div class="tools">
      <div class="title">
        办赛工具
      </div>
      <div style="display: flex; flex-flow: wrap; padding: 0 12px; justify-content: space-between;">
        <div v-for="(item, index) in imgs" :key="index">
          <div v-if="item.show" class="tool" @click="goPages(item.label, item.is)">
            <van-image style="width: 52px; height: 52px;" :src="item.img"></van-image>
            <div style="color: #333333; font-size: 14px; margin-top: 11px">{{ item.label }}</div>
          </div>
        </div>
        <div>
          <div class="tool" @click="goPlayer">
            <div class="img">
              <img :src="require('../../assets/match-detail/13.png')" />
            </div>
            <div style="color: #333333; font-size: 14px; margin-top: 11px">球员卡订单</div>
          </div>
        </div>
        <div v-if="match.liveScoreboardOpen == 1 || true">
          <div class="tool" @click="goScoreboard">
            <div class="img">
              <img :src="require('../../assets/match-detail/14.png')" />
            </div>
            <div style="color: #333333; font-size: 14px; margin-top: 11px">记分台</div>
          </div>
        </div>
        <div style="width: 109px;"></div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" >
      <van-picker
        title="选择场地"
        value-key="name"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, Toast, Popup, Picker } from 'vant'
Vue.use(VanImage).use(Toast).use(Popup).use(Picker)
const imgs = [
  { img: require('../../assets/match-detail/01.png'), label: '参赛名单', is: true, show: true },
  { img: require('../../assets/match-detail/02.png'), label: '现场检录', is: true, show: true },
  { img: require('../../assets/match-detail/03.png'), label: '赛程管理', is: true, show: true },
  { img: require('../../assets/match-detail/04.png'), label: '比分录入', is: true, show: true },
  { img: require('../../assets/match-detail/05.png'), label: '技术统计', is: true, show: true },

  // { img: require('../../assets/match-detail/06.png'), label: '直播管理', is: true, show: true },
  // { img: require('../../assets/match-detail/07.png'), label: '照片上传', is: true, show: true },
  // { img: require('../../assets/match-detail/08.png'), label: '视频上传', is: true, show: true },
  // { img: require('../../assets/match-detail/09.png'), label: '新闻公告', is: true, show: true },
  // { img: require('../../assets/match-detail/10.png'), label: '数据导出', is: true, show: true },
  { img: require('../../assets/match-detail/11.png'), label: '名次管理', is: true, show: true },
  { img: require('../../assets/match-detail/12.png'), label: '权限管理', is: true, show: true },
  // { img: require('../../assets/match-detail/13.png'), label: '记分台', is: true, show: true },

]
import { adminGetBMUnionMatch, getUserRoles } from '@/api/match'
import { adminGetUnionMatchFields } from '@/api/match-team-game'
import { QNImageUtil } from '@/utils'
export default {
  data() {
    return {
      match: {},
      imgs: imgs,
      unionMatchId: '',
      accountId: '',
      isManager: false,
      show: false,
      columns: ['1号台', '2号台','3号台','4号台', '5号台','6号台']
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    adminGetBMUnionMatch({ id: this.unionMatchId }).then(res => {
      this.match = res.data.match
      if(this.match.liveScoreboardOpen == 1){
        this.adminGetUnionMatchFields()
      }
      localStorage.setItem('entry-match', JSON.stringify(this.match))
      this.accountId = this.match.accountId
      getUserRoles({ accountId: this.accountId, unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        const list = data.list
        const roleIds = list.roles || ''
        this.isManager = roleIds.indexOf('1') > -1 || roleIds.indexOf('2') > -1 || roleIds.indexOf('4') > -1 || roleIds.indexOf('5') > -1 || roleIds.indexOf('7') > -1
      })
    })
  },
  methods: {
    goScoreboard() {
      if (this.match.sportType === '乒乓球') {
        this.show = true
      } else {
        this.$router.push({ path: `/match-manage/volleyball-points/${this.unionMatchId}` })
      }
    },
    adminGetUnionMatchFields() {
      adminGetUnionMatchFields({ unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        this.columns = data.list
      })
    },
    onConfirm(item) {
      this.$router.push({ path: `/match-manage/scoring-table-list/${this.unionMatchId}`, query: { fieldId: item.id } })
      this.show = false
    },
    goPages(label, is) {
      if (!is) return Toast('敬请期待～')
      if (label === '权限管理') {
        if (!this.isManager) {
          Toast.fail('该角色暂无权限')
          return
        }
        this.$router.push({ path: `/match-manage/match-manager/${this.match.id}` })
      } else if (label === '现场检录') {
        const userAgent = window.navigator.userAgent
        if (userAgent.indexOf('Banma') > -1) {
          this.$router.push({ path: `/match-manage/roll-call-setting/${this.match.id}` })
        } else {
          Toast('请在App中使用')
        }
      } else {
        this.$router.push({ path: `/match-manage/match-group/${this.match.id}`, query: { label } })
      }
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    goBack() {
      const userAgent = window.navigator.userAgent
      if (userAgent.indexOf('Banma') > -1) {
        window.location.href = 'banmabang://union?id=' + this.unionMatchId
      } else {
        this.$router.replace({ path: `/union-match/manage-match-list` })
      }
    },
    goPlayer() {
      if (this.match.resellerId) {
        this.$router.push({ path: `/match-manage/player-card-order-list/${this.unionMatchId}`, query: { resellerId: this.match.resellerId, objType: 'union_match' } })
      } else {
        this.$router.push({ path: `/match-manage/set-player-card/${this.unionMatchId}?&objType=union_match` })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.match-detail {
  min-height: 100vh;
  background-color: #FFFFFF;

  .match {
    background-color: #FFFFFF;
    padding: 18px 12px;

    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        margin: 0 26px 0 8px;
        font-size: 15px;
        color: #191919;
        font-weight: 500;
      }

      .account-name {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        margin: 0 26px 0 8px;
        font-size: 12px;
        color: #191919;
      }

      .cut {
        min-width: 64px;
        padding: 6px 0;
        background: #F0F5FF;
        border-radius: 16px;
        border: 1px solid #E6EEFF;
        color: #1565FC;
        text-align: center;
        font-size: 12px;
      }
    }
  }

  .tools {
    background-color: #FFFFFF;

    .title {
      background-color: #FFFFFF;
      height: 52px;
      color: #474747;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tool {
      padding-top: 11px;
      width: 109px;
      height: 92px;
      display: flex;
      flex-flow: column;
      align-items: center;

      .img {
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 51px;
        width: 51px;
        border: 1px solid #F5F5F5;
        font-size: 0;
        box-sizing: border-box;

        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}
</style>
